import styled from 'styled-components'
import theme from '../../theme/theme';

export const CardWrapper = styled.div`
  display: flex;
  padding: 20px;
  width: auto;
  max-width: 500px;
  font-family: 'Inter', sans-serif;
  @media (max-width: 400px) {
    padding: 10px;
  }
`;

export const CardTitle = styled.h2`
  font-family: 'Inter', sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: ${theme.color.navy};
  margin: 0;
  margin-bottom: 20px;
`;

export const BookingDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;
`; 

export const Card = styled.div`
  background-color: ${theme.color.white};
  border-radius: 14px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3);  
  display: table;
  width: 450px;
  height: auto;
  min-height: 10em;
  padding: 30px;
  font-family: 'Inter', sans-serif;
  @media (max-width: 400px) {
    width: 100%;
    padding: 10px;
  }
`; 